<template>
  <div :busy="isBusy">
    <b-row class="mt-3 mb-3">
      <b-col>
        <b-button block variant="danger" @click="fromLoad('add')">{{
          $l("btn_doc_add") || "上传文件"
        }}</b-button>
      </b-col>
    </b-row>
    <b-row
      class="mt-1 file-row-style"
      v-for="(item, index) in tableData"
      :key="index"
    >
      <b-col>
        <b-row class="d-flex">
          <b-col class="col-auto p-2 d-flex justify-content-start">
            <b-badge
              class="file-badge-style"
              :variant="
                item.fileExt === '.xls'
                  ? 'success'
                  : item.fileExt === 'xlsx'
                  ? 'success'
                  : item.fileExt === '.doc'
                  ? 'primary'
                  : item.fileExt === 'docx'
                  ? 'primary'
                  : item.fileExt === '.ppt'
                  ? 'warning'
                  : item.fileExt === 'pptx'
                  ? 'warning'
                  : item.fileExt === '.jpg'
                  ? 'info'
                  : item.fileExt === '.png'
                  ? 'info'
                  : item.fileExt === '.psd'
                  ? 'info'
                  : item.fileExt === 'jpeg'
                  ? 'info'
                  : item.fileExt === '.zip'
                  ? 'dark'
                  : item.fileExt === '.rar'
                  ? 'dark'
                  : item.fileExt === '.pdf'
                  ? 'danger'
                  : 'secondary'
              "
            >
              <span style="font-size: 16px">{{ item.fileExt }}</span>
            </b-badge>
          </b-col>
          <b-col class="col p-0 d-flex flex-column mt-1 mb-1 mr-2">
            <span class="text-file-type">{{ item.prjFileTypeName }}</span>
            <el-tooltip placement="left" effect="light">
              <div slot="content" v-html="item.tipPrjFileDesc"></div>
              <span
                class="text-muted text_description"
                style="font-size: 13px"
                >{{ item.prjFileDesc }}</span
              >
            </el-tooltip>
          </b-col>
        </b-row>
        <b-row class="d-flex justify-content-between mb-1">
          <b-col class="col-auto p-2 d-flex justify-content-start">
            <span class="text-muted" style="font-size: 13px"
              >{{ item.uploadName }} at {{ item.uploadTimeShort }}</span
            >
          </b-col>
          <b-col class="d-flex justify-content-end">
            <b-button variant="light" size="sm" v-if="item.isCanDelete === 'Y'">
              <b-icon
                icon="x"
                font-scale="1.5"
                aria-hidden="true"
                style="color: #fa5c7c"
                @click="deleteDoc(item)"
              ></b-icon>
            </b-button>
            <b-button class="ml-2" variant="light" size="sm">
              <b-icon
                icon="download"
                font-scale="1.5"
                aria-hidden="true"
                style="color: #98a6ad"
                @click="dowloadDoc(item)"
              ></b-icon>
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <doc-add ref="docAdd" :params="params" @success="saveSuccess" />
  </div>
</template>
<script>
import DocAdd from "../../../edit/components/doc/components/docAdd";
export default {
  components: { DocAdd },
  props: {
    params: {
      default: null,
      type: Object,
    },
    disabled: {
      default: true,
      type: Boolean,
    },
    autoLoad: {
      default: false,
      type: Boolean,
    },
    height: {
      default: 272,
      type: Number,
    },
  },
  watch: {
    params: {
      handler() {
        if (this.autoLoad) {
          this.init(this.params);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      isEmpty: false,
      isBusy: false,
      max: 100,
      searchForm: {
        prjCode: "",
        searchKeyWord: "",
      },
      tableData: [],
      page: {
        curPage: 1,
        pageSize: 100,
        pageTotal: 0,
      },
    };
  },
  methods: {
    load(params) {
      this.init(params);
    },
    init(params) {
      if (params.prjCode === "") {
        return;
      }
      if (params.prjCode != "") {
        this.searchForm.prjCode = params.prjCode;
        this.page.pageTotal = 0;
        this.page.curPage = 1;
        this.page.pageSize = 100;
        this.getData(this.searchForm);
      }
    },
    getData(params) {
      this.isBusy = true;
      this.$api
        .infoDocListApi({
          ...(params || this.params),
          ...this.page,
        })
        .then((res) => {
          this.isBusy = false;
          let totalCount = res.body.count;
          this.tableData = res.body.data;
          if (totalCount > 0) {
            this.isEmpty = false;
            this.page.pageTotal = res.body.count;
            this.page.curPage = res.body.curPage;
            this.page.pageSize = res.body.pageSize;

            this.tableData.forEach((item) => {
              if (item.prjFileDesc !== null) {
                // 替换项目说明中的空格
                item.tipPrjFileDesc = item.prjFileDesc
                  .replace(/ /g, "&nbsp;")
                  .replace(/\n/g, "<br/>");
              }
            });
          } else {
            this.isEmpty = true;
          }
        })
        .catch(() => {
          this.isBusy = false;
        });
    },
    deleteDoc(row) {
      let delParams = {
        docList: [row],
      };
      console.log(JSON.stringify(delParams));
      this.$confirm(this.$l("tips_delete") || "是否删除？", {
        confirmButtonText: this.$l("INDEX.tips_confirm") || "确认",
        cancelButtonText: this.$l("INDEX.tips_cancel") || "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.infoDocDelApi(delParams).then(() => {
            this.getData();
            this.$message({
              showClose: true,
              message: this.$l("tips_delete_ok") || "删除成功！",
              type: "success",
            });
          });
        })
        .catch(() => {});
    },
    // 下载文件 row.scmFileUrl
    dowloadDoc(row) {
      if (row.prjFileUrl) {
        // 兼容之前上传的有记录完整路径的上传文档
        window.open(row.prjFileUrl);
      } else {
        this.$api.SYS_FILEDOWNLOAD(row.prjFileCode)
      }
    },
    getTime() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let hours = date.getHours();
      let minutes = date.getMinutes();
      let seconds = date.getSeconds();
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        "-" +
        hours +
        "-" +
        minutes +
        "-" +
        seconds
      );
    },
    // 上传文件
    fromLoad() {
      this.$refs.docAdd.load();
    },
    saveSuccess() {
      this.getData();
      this.$emit("refreshComments");
    },
  },
};
</script>
<style lang="scss">
.file-row-style {
  background: #fff;
  border-radius: 0.1875rem;
  margin-left: 0px;
  margin-right: 0px;
}
.text-file-type {
  font-size: 14px;
  color: #5a5a5a;
}
.text-muted {
  font-size: 14px;
  color: #6c757d !important;
}
.text_description {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  height: 40px;
  line-height: 20px;
}
</style>